// src/components/checkout/paymentMethod.js

import React from 'react';

const PaymentMethod = ({ selected, onChange }) => {
  React.useEffect(() => {
    onChange('PHONEPE');
  }, []);

  return (
    <div className="space-y-4">
      {/* PhonePe Option */}
      <div className="border-2 border-purple-500 bg-purple-50 rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center flex-1">
            <div className="mr-4">
              <svg className="w-6 h-6 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <div className="font-semibold text-lg text-gray-900">Online Payment</div>
              <div className="text-sm text-gray-600 mt-1">
                Pay securely with UPI, Credit Card, Debit Card, Net Banking via PhonePe
              </div>
            </div>
          </div>
          <img
            src="/assets/payment/PhonePe-Logo.wine.svg"
            alt="PhonePe"
            className="h-10 ml-4"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      </div>

      {/* Accepted Methods
      <div className="bg-gray-50 rounded-lg p-4">
        <p className="text-xs text-gray-600 mb-3 font-medium">Accepted Payment Methods:</p>
        <div className="flex flex-wrap gap-3 items-center">
          <div className="bg-white px-3 py-2 rounded border text-xs font-medium text-gray-700 shadow-sm">📱 UPI</div>
          <div className="bg-white px-3 py-2 rounded border text-xs font-medium text-gray-700 shadow-sm">💳 Credit Card</div>
          <div className="bg-white px-3 py-2 rounded border text-xs font-medium text-gray-700 shadow-sm">💳 Debit Card</div>
          <div className="bg-white px-3 py-2 rounded border text-xs font-medium text-gray-700 shadow-sm">🏦 Net Banking</div>
          <div className="bg-white px-3 py-2 rounded border text-xs font-medium text-gray-700 shadow-sm">👛 Wallets</div>
        </div>
      </div> */}

      {/* Security */}
      <div className="flex items-start gap-2 p-4 bg-green-50 rounded-lg border border-green-200">
        <svg className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
        </svg>
        <div className="text-sm">
          <span className="font-medium text-green-900">100% Secure Payment</span>
          <p className="text-green-700 mt-0.5">Your payment information is encrypted and secure</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;